import { Row, Col, Form, Button } from "react-bootstrap";
import { RiSearchLine } from "react-icons/ri";
import { PiExport } from "react-icons/pi";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { errorAlert } from "../common/Alert";
import { getDriversList, getParkingLocationsDropDownList } from "../../services/Networkcall";

function DriverFilters({ filters, setFilters }) {
  const [driverList, setDriverList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [locationOptions, setLocationOptions] = useState([]);

  const statusOptions = [
    { value: "All", label: "All Status" },
    { value: "ACTIVE", label: "ACTIVE" },
    { value: "INACTIVE", label: "INACTIVE" },
  ];

  // ===============DRIVERS LIST======================
  const fetchDriversList = async () => {
    setLoading(true);
    try {
      const res = await getDriversList();
      if (res?.success) {
        const options = [
          { value: "", label: "All Drivers" },
          ...(res.data || []).map((driver) => ({
            value: driver.userName,
            label: driver.userName,
          })),
        ];
        setDriverList(options);
      } else {
        errorAlert({ message: res?.message })
      }
    } catch (err) {
      errorAlert({ message: err?.response?.data?.message || err?.message || "Something went wrong." })
    } finally {
      setLoading(false);
    }
  }


  const fetchParkingLocationsDropDownList = async () => {
    try {
      const res = await getParkingLocationsDropDownList();
      if (res?.success) {
        const options = [
          { label: "All Yards", value: "" },
          ...(res?.data || []).map((item) => ({
            label: item?.locationName,
            value: item?._id,
          })),
        ];
        setLocationOptions(options);
      }
      else {
        errorAlert({ message: res?.message })
      }
    } catch (err) {
      errorAlert({ message: err?.response?.data?.message || err?.message || 'something went wrong' })
    }
  }

  useEffect(() => { fetchParkingLocationsDropDownList(); }, [])


  useEffect(() => {
    fetchDriversList();
  }, []);


  return (
    <Row className="da-filters gap-2 m-1">

      <Col xl={4} md={12} className="p-0 m-0">

        <div className="search">
          <RiSearchLine />
          <input placeholder="Search by driver name or phone..."
            value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value })} />
        </div>
      </Col>

      <Col xl={2} md={4} className="m-0">
        <Select
          options={statusOptions}
          value={statusOptions.find(s => s?.value === filters?.status)}
          onChange={(option) =>
            setFilters({ ...filters, status: option?.value })
          }
          components={{
            IndicatorSeparator: () => null,
          }}
          menuPlacement="bottom"
        />
      </Col>

      <Col xl={2} md={4} className="m-0">
        <Select
          options={locationOptions}
          value={locationOptions.find(l => l?.value === filters?.locationId)}
          onChange={(option) =>
            setFilters({ ...filters, locationId: option?.value })
          }
          components={{
            IndicatorSeparator: () => null,
          }}
          menuPlacement="bottom"
        />
      </Col>

      <Col xl={2} md={4} className="m-0">
        <Select
          options={driverList}
          value={driverList.find(d => d?.value === filters?.driver)}
          onChange={(option) =>
            setFilters({ ...filters, driver: option?.value })
          }
          components={{
            IndicatorSeparator: () => null,
          }}
          menuPlacement="bottom"
        />
      </Col>

      {/*  <Col xl={2} md={12}>
        <Button className="export-btns" variant="outline-secondary"><PiExport/>  Export</Button>
      </Col> */}

    </Row>
  );
}

export default React.memo(DriverFilters);